import { useAtomValue } from "jotai";

import { SampleHandProvider } from "~/providers/SampleHandProvider";
import { decklistJotai } from "~/state/deckJotai";
import { SampleHand } from "./SampleHand";

export const HandSimulator = () => {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const decklist = useAtomValue(decklistJotai)!;
  return (
    <SampleHandProvider decklist={decklist}>
      <SampleHand />
    </SampleHandProvider>
  );
};
